import { StatusCodes } from "http-status-codes";
import Axios from "../utils/axiosInterceptor";
import { AYUSHMAN_B } from "../utils/constants";
import { IPatient, IPatientFetchDetailsFromAyushBPortal } from "../interfaces/IPatient";


export const postSchemeToGetPatientAyushB = async (
  data: IPatientFetchDetailsFromAyushBPortal,hospitalId: any
) => {
  try {
    const response = await Axios.get<IPatient>(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${data?.portalMetaDataId}/beneficiaryId/${data?.beneficiaryId}/fetchPatientDetails`
      //  `${AYUSHMAN_B.BASE_URL}/portalMetaData/${data.portalMetaDataId}/fetchPatientDetails`,{
      //   beneficiaryId:data?.beneficiaryId,
      //   hospityalId:hospitalId
      //  }
    );

    return { patient: response.data, status: response.status };
  } catch (error: any) {
    if (
      error?.response?.data
        ?.toLowerCase()
        ?.includes("something went wrong from fetching the details from portal")
    ) {
      throw new Error("Portal inactive. Add patient details manually");
    }
    console.error("Error fetching patient details from portal:", error);
    throw new Error("Cannot fetch patient details");
  }
};

//for portal registration
export const registerPatientPortal = async (
  data: any
) => {
  try {
    const response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/registration`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data.message || "Unable to do Portal Registration"
    );
  }
};

// Ayushman PreAuth
export const fetchPortalData = async (caseId: number, visitId: number) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/getAllCasePreAuthByCaseIdAndVisitId`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get portalData:", error);
    throw new Error(error?.response?.data || "Failed to get portal data");
  }
};

export const updateAyushBPreAuth = async (data: any) => {
  try {
    let response = await Axios.patch(
      `${AYUSHMAN_B.BASE_URL}/cases/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/casePreAuthId/${data?.params?.casePreAuthId}`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { preAuthSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot update PreAuth details:", error);
    throw new Error(error?.response?.data || "Cannot update PreAuth details");
  }
};

export const createAyushBPreAuth = async (data: any) => {
  try {
    let response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/cases/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/casePreAuth`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { preAuthSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot create PreAuth details:", error);
    throw new Error(error?.response?.data || "Cannot create PreAuth details");
  }
};

export const updateDraftAyushman = async (caseId: number, visitId: number, casePreAuthId: number, formData: any) => {
  try {
    const response = await Axios.patch(
      `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/casePreAuthId/${casePreAuthId}`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update Pre Auth details");
  }
}

export const saveDraftAyushman = async (caseId: number, visitId: number, formData: any) => {
  try {
    const response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/casePreAuth`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot save Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot save Pre Auth details");
  }
}


export const postAyushBPreAuth = async (data: any) => {
  try {
    let response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/cases/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/initiateCasePreAuth`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { preAuthSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot submit PreAuth details:", error);
    throw new Error(error?.response?.data || "Cannot submit PreAuth details");
  }
};

export const postPreAuthToPortalAyushman = async (
  caseId: number,
  visitId: number,
  payload: any
): Promise<any> => {
  try {
    const response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/initiateCasePreAuth`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot post Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post Pre Auth details");
  }
};

export const fetchSpecialities = async (portalMetaDataId: number) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/speciality`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get specialities:", error);
    throw new Error(error?.response?.data || "Failed to get specialities");
  }
};

// export const fetchProcedures = async (portalMetaDataId: number) => {
//   try {
//     const res = await Axios.get(
//       `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/procedure`
//     );
//     return res.data;
//   } catch (error: any) {
//     console.error("Failed to get procedures:", error);
//     throw new Error(error?.response?.data || "Failed to get procedures");
//   }
// };

export const fetchProcedures = async (payload: any) => {
  try {
    const res = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/procedures`, payload
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get procedures:", error);
    throw new Error(error?.response?.data || "Failed to get procedures");
  }
};

export const fetchStratifications = async (portalMetaDataId: number, procedure: string) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/procedure/${procedure}/stratification`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get stratifications:", error);
    throw new Error(error?.response?.data || "Failed to get stratifications");
  }
};

export const fetchDoctors = async (portalMetaDataId: number, data: any) => {
  try {
    const res = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/doctor`, data?.specialityCodes
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get doctors:", error);
    throw new Error(error?.response?.data || "Failed to get doctors");
  }
};

export const fetchDiagnosis = async (portalMetaDataId: number, searchTerm: string) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/searchTerm/${searchTerm}/diagnosis`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get diagnosis:", error);
    throw new Error(error?.response?.data || "Failed to get diagnosis");
  }
};

export const fetchInvestigations = async (portalMetaDataId: number, data: any) => {
  try {
    const res = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/investigations`, data
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get investigations:", error);
    throw new Error(error?.response?.data || "Failed to get investigations");
  }
};

export const fetchImplants = async (portalMetaDataId: number, data: any) => {
  try {
    const res = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/portalMetaData/${portalMetaDataId}/implant`, data?.procedureCodes
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get implants:", error);
    throw new Error(error?.response?.data || "Failed to get implants");
  }
};



//  Ayushman Claim
export const fetchAyushBClaimData = async (caseId: number, visitId: number, portalMetaDataId: number) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalMetaDataId}/caseClaimSubmission`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get portalData:", error);
    throw new Error(error?.response?.data || "Failed to get portal data");
  }
};

export const getPreAuthClaimAyushmanBharat = async (caseId: number, visitId: number, portalMetaDataId: number) => {
  try {
    const response = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalMetaDataId}/caseClaimSubmission`
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot get claim details",
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot get claim details:", error);
    throw new Error(error?.response?.data || "Cannot get claim details");
  }
};

export const fetchAyushBClaimFinanceData = async (claimId: number,) => {
  try {
    const res = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/claimId/${claimId}/fetchPatientFinanceDetails`
    );
    return res.data;
  } catch (error: any) {
    console.error("Failed to get finance details:", error);
    throw new Error(error?.response?.data || "Failed to get finance details");
  }
};

export const postAyushBClaim = async (data: any) => {
  try {
    let response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/portalMetaData/${data?.params?.portalMetaDataId}/caseClaimSubmission`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post Claim details:", error);
    throw new Error(error?.response?.data || "Cannot post Claim details");
  }
};

export const createAyushBClaim = async (data: any) => {
  try {
    let response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/portalMetaData/${data?.params?.portalMetaDataId}/createCaseClaim`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post PreAuth details:", error);
    throw new Error(error?.response?.data || "Cannot post Claim details");
  }
};

export const updateAyushBClaim = async (data: any) => {
  try {
    let response = await Axios.patch(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${data?.params?.caseId}/visitInfo/${data?.params?.visitId}/caseClaim/${data?.params?.caseClaimId}/createCaseClaim`,
      data?.data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post PreAuth details:", error);
    throw new Error(error?.response?.data || "Cannot post Claim details");
  }
};

export const postPreAuthClaimToEdgeProAyushmanB = async (
  data: any,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<any> => {
  try {
    let response;
    const baseUrl = `${AYUSHMAN_B.BASE_URL}/casesNew/${caseId}/visitInfo/${visitId}`;
    if (caseClaimId === null) {
      // POST request
      response = await Axios.post(
        `${baseUrl}/portalMetaData/${portalId}/createCaseClaim`,
        data
      );
    } else {
      response = await Axios.patch(
        `${baseUrl}/caseClaim/${caseClaimId}/createCaseClaim`,
        data
      );
    }
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot post claim details:", error);
    throw new Error("Cannot post claim details");
  }
};

export const postPreAuthClaimAyushmanB = async (
  data: any,
  caseId: number,
  visitId: number,
  portalId: number
): Promise<any> => {
  try {
    const response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimSubmission`,
      data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const submitApprovalAyushmanB = async (formData: any) => {
  try {
    const res = await Axios.post(`${AYUSHMAN_B.BASE_URL}/approve`, formData);
    return res.data;
  } catch (error) {
    throw new Error("Failed to Approve");
  }
};

export const intimateClaimAyushmanB = async (
  data: any,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<any> => {
  try {
    let response;
    const baseUrl = `${AYUSHMAN_B.BASE_URL}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimIntimate`;
      response = await Axios.post(
        `${baseUrl}`,
        data
      );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot intimate claim details:", error);
    throw new Error("Cannot intimate claim details");
  }
};

export const register = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${AYUSHMAN_B.BASE_URL}/caseId/${caseId}/visitId/${visitId}/register`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in registration:", error);
    throw error;
  }
};

export const otpVerify = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${AYUSHMAN_B.BASE_URL}/caseId/${caseId}/visitId/${visitId}/otp_verify`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in otp verification:", error);
    throw error;
  }
};

export const registerValidation = async (data: any) => {
  try {
    const response = await Axios.post(
      `${AYUSHMAN_B.BASE_URL}/registration/validate`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot validate registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot validate registration details");
  }
};

export const getRegisterValidation = async (registrationId: any, visitId: any) => {
  try {
    const response = await Axios.get(
      `${AYUSHMAN_B.BASE_URL}/registration/${registrationId}/visitId/${visitId}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot get validation registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot get validation registration details");
  }
};

export const updateRegistrationValidationDetails = async (caseId: any, visitId: any, data: any) => {
  try {
    const response = await Axios.patch(
      `${AYUSHMAN_B.BASE_URL}/registration/caseId/${caseId}/visitId/${visitId}/update`, data
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update validation registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update validation registration details");
  }
};

export const submitIdAyushmanBharat = async (
  caseId: number,
  visitId: number,
  schemeId: number,
  formData: any
) => {
  try {
    const res = await Axios.patch(
      `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`,
      formData
    );
    return res.data;
  } catch (error) {
    throw new Error("Failed to Update Id");
  }
};

export const fetchEnhancementDataAyushman = async (
  caseId: string | number,
  visitId: string | number,
) => {
  const response = await Axios.get(
    `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitId}/getAll`,
  );
  return response.data;
};

export const enhancementServiceAyushman = {
  saveEnhancementData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number,
    _caseEnhancementId: string | null,
    payload: any,
  ): Promise<void> => {
    try {
      const response = await Axios.post(
        `${AYUSHMAN_B.BASE_URL}/cases/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/caseEnhancement`,
        payload,
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },
};